module.exports = __webpack_public_path__ + "static/img/gaozhonghuaxue2.add4613f.jpg";